export default {
  'our-cause': () => {
    return '/pt/sobre/nossa-missao';
  },
};
